import { render, staticRenderFns } from "./standart-select.vue?vue&type=template&id=67068366&"
import script from "./standart-select.vue?vue&type=script&lang=ts&"
export * from "./standart-select.vue?vue&type=script&lang=ts&"
import style0 from "./standart-select.vue?vue&type=style&index=0&id=67068366&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports